import OddsSelector from "app/components/OddsSelector/OddsSelector";
import { UpdateOddsHelper } from "app/helpers/updateOddsHelper";
import {
  competitionListTimeEnum,
  MarketTypes,
  OddsType,
  TabTypes,
} from "app/utils/const";
import isPublicView from "app/utils/publicViewUtils";
import isEmpty from "lodash/isEmpty";
import React, { Component } from "react";
import "react-dropdown/style.css";
import type { IntlShape } from "react-intl";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { LoadFilterOptionsHelper } from "../../helpers/LoadFilterOptionsHelper/LoadFilterOptionsHelper";
import CompetitionListTitle from "../CompetitionListTitle/CompetitionListTitle";
import DatesFilter from "../DatesFilter/DatesFilter";
import Leagues from "../Leagues/Leagues";
import Lines from "../Lines/Lines";
import PreGame from "../PreGame/PreGame";
import Sorting from "../Sorting/Sorting";
import "./AsianGlobalEventsNavigation.scss";
import AsianLeaguesSelector from "./AsianLeaguesSelector/AsianLeaguesSelector";
type Props = {
  isActive: boolean;
  isLightWhenActive: boolean;
  currentBetsCount: number;
  loadCurrentBetsCount: (...args: Array<any>) => any;
  isIdle: boolean;
  intl: IntlShape;
  selectLine: (...args: Array<any>) => any;
  selectSorting: (...args: Array<any>) => any;
  selectedSportName: string;
  selectedSportTimeFrame: string;
  sportsSelectionLoaded: boolean;
  user: Record<string, any>;
  loadUser: (...args: Array<any>) => any;
  handleChangeOddsType: (...args: Array<any>) => any;
  bookmarksOnly: boolean;
  favouritesOnly: boolean;
  unfilteredCompetitionCount: number;
  filteredCompetitionCount: number;
  selectLeagues: (...args: Array<any>) => any;
  orderBy: string;
  updateSportsSelection: (...args: Array<any>) => any;
  translatedSportName: string;
  line: string;
  togglePreGameEventsOnly: (...args: Array<any>) => any;
  asianPreGameEventsOnly: boolean;
  pregameOptions: Record<string, any>;
  oddsOptions: { label: string; value: string }[];
  sortingOptions: Record<string, any>;
  lineOptions: Record<string, any>;
  showUnsummarizedMarketsModal: boolean;
  selectedMarketType: string;
};
type State = {
  selectedOdds: any;
  showLeaguesSelector: boolean;
  datesWithEvents: Record<string, any>[];
  initialised: boolean;
};

class AsianGlobalEventsNavigation extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      selectedOdds: undefined,
      showLeaguesSelector: false,
      datesWithEvents: [],
      initialised: false,
    };
  }

  updateOdds = (odds: string) => {
    UpdateOddsHelper.updateOdds(odds, this.props.handleChangeOddsType);
  };
  toggleLeaguesSelector = (e: Record<string, any>) => {
    e && e.preventDefault();
    this.setState({
      showLeaguesSelector: !this.state.showLeaguesSelector,
    });
  };
  componentDidUpdate = (
    prevProps: Record<string, any>,
    prevState: Record<string, any>
  ) => {
    // BET-5049 update UNSAFE deprecated lifecycle
    const { user } = this.props;

    if (!isEmpty(user.preferences)) {
      // if odds type of probabilty selected change odds type to decimal on API
      // as probabilty odds type not used in asian view
      if (
        !isEmpty(prevProps.user.preferences) &&
        prevProps.user.preferences["oddsType"] === OddsType.PROBABILITY &&
        prevState.selectedOdds === undefined
      ) {
        this.updateOdds(OddsType.DECIMAL);
      } else {
        if (
          !isEmpty(prevProps.user.preferences) &&
          prevState.selectedOdds !== user.preferences["oddsType"]
        ) {
          this.setState({
            selectedOdds: user.preferences["oddsType"],
          });
        }
      }
    }
  };
  componentDidMount = () => {
    // get latest user details from account API
    !isPublicView() && this.props.loadUser();
    // load once and keep data in store instead of loading on each render
    LoadFilterOptionsHelper.loadFilterOptions(this.props.intl);
  };

  render() {
    const {
      bookmarksOnly,
      favouritesOnly,
      intl,
      oddsOptions,
      pregameOptions,
      sortingOptions,
      lineOptions,
      translatedSportName,
      selectedSportName,
      selectedSportTimeFrame,
      sportsSelectionLoaded,
      togglePreGameEventsOnly,
      asianPreGameEventsOnly,
      selectLine,
      line,
      selectSorting,
      orderBy,
      showUnsummarizedMarketsModal,
      selectedMarketType,
      // liveTodayEarly,
    } = this.props;

    const disableFilters = !sportsSelectionLoaded;
    const isHandicap =
      !selectedMarketType || selectedMarketType === MarketTypes.HANDICAP
        ? true
        : false;

    const disableLineFilter = !isHandicap || !sportsSelectionLoaded;

    const disablePreGameFilter =
      selectedSportTimeFrame === TabTypes.LIVE ||
      selectedSportTimeFrame === competitionListTimeEnum.EARLY ||
      bookmarksOnly ||
      favouritesOnly ||
      disableFilters;

    return (
      <React.Fragment>
        <div
          className={`asian-global-events-navigation ${
            showUnsummarizedMarketsModal === true ? "suspended" : ""
          }`}
        >
          <CompetitionListTitle
            bookmarksOnly={bookmarksOnly}
            favouritesOnly={favouritesOnly}
            translatedSportName={translatedSportName}
            selectedSportName={selectedSportName}
            selectedSportTimeFrame={selectedSportTimeFrame}
          />
          <span className="global-event-navigation">
            {selectedSportTimeFrame === competitionListTimeEnum.EARLY &&
              !bookmarksOnly &&
              !favouritesOnly &&
              selectedMarketType !== MarketTypes.OUTRIGHT && (
                <DatesFilter intl={intl} disabled={disableFilters} />
              )}

            {selectedSportTimeFrame === competitionListTimeEnum.TODAY &&
              !bookmarksOnly &&
              !favouritesOnly && (
                <PreGame
                  pregameOptions={pregameOptions}
                  disablePreGameFilter={disablePreGameFilter}
                  togglePreGameEventsOnly={togglePreGameEventsOnly}
                  asianPreGameEventsOnly={asianPreGameEventsOnly}
                />
              )}
            <Lines
              lineOptions={lineOptions}
              selectLine={selectLine}
              line={line}
              disabled={disableLineFilter}
            />
            <Sorting
              sortingOptions={sortingOptions}
              bookmarksOnly={bookmarksOnly}
              favouritesOnly={favouritesOnly}
              selectSorting={selectSorting}
              sortingType={orderBy}
              disabled={disableFilters}
            />
            <OddsSelector
              oddsOptions={oddsOptions}
              updateOdds={this.updateOdds}
              selectedOdds={this.state.selectedOdds}
              disabled={disableFilters}
            />
            <Leagues
              props={this.props}
              toggleLeaguesSelector={this.toggleLeaguesSelector}
              disabled={disableFilters}
            />
          </span>
        </div>
        {this.state.showLeaguesSelector && (
          <AsianLeaguesSelector
            selectLeagues={this.props.selectLeagues}
            showLeaguesSelector={this.state.showLeaguesSelector}
            toggleLeaguesSelector={this.toggleLeaguesSelector}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  currentBetsCount: state.betSlipListModel.currentBetsCount,
  isIdle: state.sessionModel.isIdle,
  selectedSportName: state.sportsSelectionListModel.selectedSportName,
  translatedSportName: state.sportsSelectionListModel.translatedSportName,
  selectedSportTimeFrame: state.sportsSelectionListModel.selectedSportTimeFrame,
  sportsSelectionLoaded: state.sportsSelectionListModel.sportsSelectionLoaded,
  user: state.userModel.user,
  bookmarksOnly: state.asianCompetitionListFiltersModel.bookmarksOnly,
  favouritesOnly: state.competitionListModel.favouritesOnly,
  unfilteredCompetitionCount:
    state.competitionListModel.unfilteredCompetitionCount,
  filteredCompetitionCount: state.competitionListModel.filteredCompetitionCount,
  orderBy: state.asianCompetitionListFiltersModel.orderBy.toLowerCase(),
  asianPreGameEventsOnly:
    state.asianCompetitionListFiltersModel.asianPreGameEventsOnly,
  pregameOptions: state.competitionListModel.pregameOptions,
  oddsOptions: state.competitionListModel.oddsOptions,
  sortingOptions: state.competitionListModel.sortingOptions,
  lineOptions: state.competitionListModel.lineOptions,
  showUnsummarizedMarketsModal:
    state.competitionListModel.showUnsummarizedMarketsModal,
  selectedMarketType: state.sportsSelectionListModel.selectedMarketType,
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    loadCurrentBetsCount: () =>
      dispatch.betSlipListModel.loadCurrentBetsCount(),
    loadUser: () => dispatch.userModel.loadUser(),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(AsianGlobalEventsNavigation)) as any;
